import { Injectable, REQUEST_CONTEXT, inject } from '@angular/core';

import { VnRequestContext } from '@frontend/vanilla/ssr';

import { WINDOW } from '../browser/window/window.token';

/**
 * @whatItDoes Provides access to manifest.json entries.
 *
 * @stable
 */
@Injectable({ providedIn: 'root' })
export class ManifestService {
    readonly #window = inject(WINDOW);
    private requestContext = inject<VnRequestContext>(REQUEST_CONTEXT);

    data: { [key: string]: string };

    constructor() {
        this.data = ((this.requestContext?.vnManifest || this.#window['vn_manifest']) as { [key: string]: string }) || {};
    }

    getEntry(entry: string): string | undefined {
        return this.data[entry];
    }
}
